import { SearchInput } from '@liveauctioneers/hammer-ui-core/searchInput';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo } from 'react';

type Props = {
    disabled?: boolean;
    placeholderMessage?: string;
    shortOnMobile?: boolean;
    submitFilterTerm: (filterTerm: string) => void;
};

const FilterTermComponent = ({ disabled, placeholderMessage = '', shortOnMobile, submitFilterTerm }: Props) => (
    <div
        className={cn('relative mr-xs flex h-[30px] flex-row items-center xsMax:mr-0', {
            'xsMax:mt-md': shortOnMobile,
        })}
    >
        <SearchInput
            className="w-[185px] border-0 xsMax:w-full [&_label>div]:pr-0"
            disabled={disabled}
            input-aria-label={placeholderMessage}
            placeholder={placeholderMessage}
            small
            onSubmit={submitFilterTerm}
        />
    </div>
);

export const FilterTerm = memo(FilterTermComponent);
